import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Uuid } from 'src/app/core/types/Uuid';


@Component({
    selector: 'app-accept-invite',
    templateUrl: './accept-invite.component.html',
    styleUrl: './accept-invite.component.scss',
    standalone: false
})
export class AcceptInviteComponent implements OnInit{
  routerParams!: Subscription;
  keyParam!: string;

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.routerParams = this.route.params.subscribe(
      (params: { [x: string]: Uuid; }): void => {
        this.keyParam = params['key-param'];
      });
  }
}
